import { connect } from 'react-redux';

import { isNewbuildingSelector, selectIsAgencyBrandingAvailable } from '../../selectors';
import { selectIsOfferWithMultiAds } from '../../selectors/offerData';
import { selectAgentLists } from '../../selectors/offerData/selectAgentLists';
import { subscriptionPriceChangesPopupOpen } from '../../store/subscription_price_changes_popup';
import { IOfferTermsDispatchProps, IOfferTermsStateProps, OfferTerms } from './index';

import type { DispatchReduxAction, IState } from '../../store';

type TOwnProps = Pick<IOfferTermsStateProps, 'priceRelevance'>;

export function mapStateToProps(state: IState, ownProps: TOwnProps): IOfferTermsStateProps {
  const {
    abGroup,
    offerData: { user, agent, trackingUrl },
    knAuctionCompanies,
    auctionBanks,
    featureToggle,
  } = state;

  return {
    abGroup,
    realtyId: agent && agent.realtyUserId ? agent.realtyUserId : undefined,
    isAgent: Boolean(state.offerData.user && state.offerData.user.isAgent),
    isAuthenticated: user && user.isAuthenticated,
    isNewBuilding: isNewbuildingSelector(state),
    isAgencyBrandingAvailable: selectIsAgencyBrandingAvailable(state),
    offer: state.offerData.offer,
    subscription: state.offerData.subscription,
    knAuctionCompanies,
    auctionBanks,
    utilitiesTermsSettings: featureToggle.utilitiesTermsSettings,
    /**
     * @todo Удалить строку с RS - "isNewMultiAddsEnabled" будет не нужен
     * @description Данный функционал появился в задаче CD-153984, будет удалён в задаче CD-151061
     */
    isNewMultiAddsEnabled: featureToggle.isNewMultiAddsEnabled,
    isCommercialOfferWithMultiAds: selectIsOfferWithMultiAds(state),
    bank: agent?.bank || undefined,
    priceRelevance: ownProps.priceRelevance,
    agentLists: selectAgentLists(state),
    trackingUrl,
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction): IOfferTermsDispatchProps {
  return {
    subscriptionPriceChangesPopupOpen: () => {
      dispatch(subscriptionPriceChangesPopupOpen());
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferTermsContainer = connect<IOfferTermsStateProps, IOfferTermsDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferTerms);
